export const extractError = (error: any) => {
  if (error.response) {
    return error.response.data.message;
  } else if (error.request) {
    return error.request;
  }
  return error.message;
};
